<template>
  <div v-if="navigationLinks.length > 0" class="navigation converter-navigation">
    <div v-if="$store.state.loading" class="page-loading">
      <div class="page-loading-bar"></div>
    </div>
    <b-navbar class="mb-5 navbar-expand main-navigation">
      <b-collapse class="main-collapse" is-nav id="nav_dropdown_collapse">
        <b-navbar-nav class="navigation-content fixed-forgrid ctrl-dir">
          <b-navbar-brand :target="logo.target" class="qazlatyn-logo mr-auto" :to="navLinkPrefix + logo.link">
            <img v-if="logoUrl !== undefined" :src="host + logoUrl" :alt="logo.name">
          </b-navbar-brand>
          <b-nav-item
            v-for="(link, index) in navigationLinks"
            :target="link.target"
            :key="index"
            :to="navLinkPrefix + link.url"
            :class="routePath === link.url ? 'active' : ''"
            class="navigation-item">
            {{ link.title  }} <i v-if="link.hasIcon === 1" :class="[link.icon]"></i>
          </b-nav-item>
          <li class="nav-item search-nav-item">
            <div class="nav-link">
              <input
                @keyup.13="searchNews"
                v-model="keyWord"
                type="text"
                class="search-input"
                :placeholder="ls_search">
              <b-link
                @click="searchNews" 
                class="search-icon"
                :placeholder="ls_search">
                <i class="far fa-search"></i>
              </b-link>
            </div>
          </li>
          <select-language></select-language>
        </b-navbar-nav>
        <!-- <b-navbar-nav class="ml-auto language-nav">
          <li class="nav-item">
            <span class="nav-link">
              <input
                @keyup.13="searchNews"
                v-model="keyWord"
                type="text"
                class="search-input"
                :placeholder="ls_search">
              <b-link
              @click="searchNews" 
                class="search-icon"
                :placeholder="ls_search">
                <i class="far fa-search"></i>
              </b-link>
            </span>
          </li>
          <li class="nav-item top-devider"></li>
          <b-nav-item class="language-icon">
            <i class="fas fa-globe"></i>
          </b-nav-item>
          <select-language></select-language>
        </b-navbar-nav> -->
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import SelectLanguage from "@/components/SelectLanguage.vue";

export default {
  data() {
    return {
      keyWord: "",
      logo: {
        name: "QazLatyn",
        link: "/home",
        target: "_blank"
      },
      navigationLinks: []
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    navLinkPrefix() {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln
        : "";
    },

    routePath() {
      return this.$route.params.ln !== undefined
        ? this.$route.path.substring(
            this.$route.path.substring(1).indexOf("/") + 1
          )
        : this.$route.path;
    },

    logoUrl() {
      return this.$store.state.siteSettings.pcLogo;
    },

    ls_search() {
      return this.$store.state.languagePack.ls_search;
    }
  },

  methods: {
    getNavigation() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("typeId", 1);
      this.$http
        .post(this.host + "/api/qazlatyn/getnavigationlist", fd)
        .then(result => {
          if (result.status === 200) {
            this.navigationLinks = result.body.data;
          } else {
            // console.log('Err');
          }
        });
    },

    searchNews() {
      if (this.keyWord.trim()) {
        this.$router.push({
          path:
            this.$route.params.ln !== undefined
              ? "/" + this.$route.params.ln + "/article"
              : "/article",
          query: {
            keyWord: this.keyWord
          }
        });
      }
    }
  },

  mounted() {
    this.getNavigation();
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getNavigation();
      }
    }
  },

  components: {
    "select-language": SelectLanguage
  }
};
</script>

<style lang="scss">
@import "src/assets/styles/common.scss";
.converter-navigation {
  background-color: #ffffff;
  position: relative;

  .page-loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 59px;
  }

  .main-navigation {
    padding: 0 !important;
    border-bottom: 1px solid #ededed;

    .language-content {
      
      .nav-link {
        background-color: #deeff1;
        border-radius: 40px;
        border: 5px solid #ffffff;
        color: #008490 !important;
        padding: 5px 10px;
      }

      .dropdown-toggle::after {
        margin-left: 10px;
      }
    }
  }

  .navigation-content {
    padding: 0 15px;

    .qazlatyn-logo {
      padding: 9px 0;

      img {
        height: 32px;
      }
    }

    .navigation-item {
      height: 58px;
      padding: 9px 8px;

      &:hover {
        background-color: #f5f5f5;
      }
    }

    .search-nav-item,
    .language-content {
      height: 58px;
      padding: 9px 0;
    }

    .navigation-item.active {
      .nav-link {
        color: #008490;
      }
    }

    .search-nav-item {
      position: relative;
      display: inline-block;
      width: 50px;
      margin-left: 32px;

      &:hover {

        .nav-link {
          width: 250px;
          border-radius: 30px;
          background-color: #deeff1;

          .search-input {
            opacity: 1;
            border-radius: 30px;
            width: 190px;
            padding: 0 10px;
          }
        }
      }

      .nav-link {
        position: absolute;
        right: 0;
        display: inline-block;
        width: 60px;
        height: 45px;
        background-color: #deeff1;
        border-radius: 40px;
        border: 5px solid #ffffff;
        color: #008490 !important;
        padding: 5px 10px;
        transition: all 0.3s ease-in-out;

        .search-input {
          display: inline-block;
          width: 0;
          height: 24px;
          opacity: 0;
          border-radius: 30px;
          border: none !important;
          background-color: transparent;
          margin-right: 5px;
          transition: all 0.3s ease-in-out;

          &:focus {
            outline: none;
            border-color: #008490;
          }
        }

        .search-icon {
          display: inline-block;
          color: #008490 !important;
        }
      }
    }
  }

  .top-devider {
    margin-top: 0.15rem;
    height: 1.675rem;
    margin-left: 2rem;
    margin-right: 2rem;
    border-left: 1px solid #ced4da;
  }
}
.converter-layout {
  .navbar-light .navbar-nav .show > .nav-link {
    color: #585858 !important;
  }
}

/* RTL */
.rtl-layout .converter-navigation {

  .qazlatyn-logo {
    margin-left: auto !important;
    margin-right: 0 !important;
  }

  .search-nav-item {
    margin-left: 0 !important;
    margin-right: 32px !important;

    .nav-link {
      direction: rtl;
      left: 0;
      right: calc(100% - 50px);

      .search-input {
        direction: rtl;
        text-align: right;
      }
    }
  }
}
</style>
